<template>
    <div class="pm ">
        <el-row class="video-tree flex" >

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <product-tree ref="tree" @showData="showData" ></product-tree>
            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%">
                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="品名" v-model="vc_search"></el-input>
                <el-button class="marB10" icon="el-icon-search" circle @click="searchFun " size="mini" ></el-button>
                <el-table class="mrt10" ref="table" row-key="wyid" size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
<!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column :label="$t('form_serial_number')" align="left" type="index" width="55"></el-table-column>
                    <el-table-column align="center" :label="$t('form_product_name')" prop="vc_pzname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" :label="$t('form_company')" prop="vc_gsname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" :label="$t('form_warehouse')" prop="vc_ckname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="货位" prop="vc_wzname"></el-table-column>
                    <el-table-column align="center" label="库号" prop="vc_no"></el-table-column>
                    <el-table-column align="center" label="货物性质" prop="i_xtype">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_xtype==0?'内销':scope.row.i_xtype==1?'外销':'电商库存'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="库存" prop="f_num"></el-table-column>
                    <el-table-column align="center" label="单位" prop="vc_unit"></el-table-column>
                    <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="scope">
                            <el-button style="padding: 5px 10px" size="mini" type="text"  @click="details(scope.row)">变更</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" @size-change="sizeChange" :page-sizes="pageSizes" layout="total,sizes,prev, pager, next" :current-page.sync="currentPage" :total="total" :page-size="pageSize"></el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="cpfltitle" width="600px" v-if="cpflVisible" :visible.sync="cpflVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <chanpin-fenlei :data="cpflData" @close="cpflClose"></chanpin-fenlei>
            </el-dialog>

        </div>


    </div>

</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import ProductTree from "./ProductTree";
    import ChanpinFenlei from "./ChanpinFenlei";

    export default {
        name: "index",
        components: {ProductTree,ChanpinFenlei,},
        data() {
            return {
                isright:true,//树显示按钮
                currentPage: 1,
                pageSize: 30,
                total:0,
                pageSizes:[30,100,200,300],
                tableData:[],
                tableHeight:0,//列表高度
                baseerp:'',
                treespan:4,
                rightspan:20,
                cpflData:{},
                cpflVisible:false,
                vc_search:'',
                i_state:1,
                infomation:'',
                cpfltitle:'',
                dataText:this.$t('tips_no_data_available_at_the_moment'),

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.getProductSpecification()

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            details(val){
                this.cpflData=val;
                this.cpfltitle='编辑产品'
                // console.log(val,'=================')

                this.cpflOpen()
            },

            searchFun(){
                this.currentPage = 1;
                this.getStockList();
            },

            cpflOpen(){
                this.cpflVisible=true;
            },
            cpflClose(type='close'){
                this.cpflVisible=false;
                if(type=='save'){
                    this.getStockList()
                }
            },


            async getStockList(){
                this.dataText=this.$t('tips_data_loading_in_progress')
                let param = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                    i_pzid:this.infomation.i_id,

                };
                let res = await API.getStockList(param);
                if (res.code == 1) {
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data.list;

                    this.total=res.data.total;
                    // this.pageSizes=this.getPageSizes(this.total);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            showData(val){
                this.infomation=JSON.parse(JSON.stringify(val)) ;
                this.zycpggList=[]
                this.$refs.table.clearSelection()
                // console.log('this.infomation=',this.infomation)
                this.currentPage = 1;
                this.getStockList();
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getStockList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getStockList();
            },
            getPageSizes(total){
                const max=Math.ceil(total/200);
                return  Array.from({length:max},(_, i)=> 200 * (i+1));
            },

        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }

    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
</style>